<div class="row">
  <div class="col-md-12">
    <h2>Supporting Documents</h2>
    <div *ngIf="alert" class="d-flex align-items-center error">
      <mat-icon>highlight_off</mat-icon>
      <p class="ml-2">{{ errorMessage }}</p>
    </div>
    <div [hidden]="allowFileUpload || lockScreen">
    <p class="sub-text">Attach supporting documents for the debt indicated above only.</p>
    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="onClickToUploadMultipleFiles($event)">
      <input hidden type="file" [accept]="allowFileType" #fileInput multiple (change)="onClickToUploadMultipleFiles($event.target.files)" onclick="this.value=null">
      <div class="d-flex flex-column align-items-center justify-content-center hght100">
        <img src="../../../../assets/images/creditor-portal/Upload.svg" alt="uploadIcon"/>
        <div class="drag_drop">Drag & Drop</div>
        <div class="upload_content">
          Upload only PDF (.pdf),  JPEG (.jpg, .jpeg), GIF (.gif), HEIC (.HEIC), Powerpoint (.ppt, .pptx), Excel (.xls, .xlsx) or DOC (.doc, .docx).<br>
          The file size of each attachment must not exceed 10MB.
        </div>
        <button type="button" class="tertiary-button">BROWSE FILE</button>
      </div>
    </div>
    </div>
    <div class="d-flex flex-row align-items-center flex-wrap">
      <div class="files-list" *ngFor="let file of azureFiles;let i=index">
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <p>
              <button type="button" (click)="readFile(file)" class="btn btn-link text-dark text-left px-0" style="font-size:15px">
                <div class="overflow"> {{ file.name }}
                  <div class="tooltiptext">  {{ file.name }} </div>
              </div>
              </button>
           
            </p>
          </div>
          <div class="col-12 col-md-6">
            <div class="d-flex flex-row align-items-center justify-content-md-end">
              <p class="text-right mr-4">
                {{file.fileSize}}
              </p>
              <p class="text-right mr-1">{{file.convertedDate}} GMT+8</p>
              <button *ngIf="(file.showDelete?false:true) && (file.isUpdate?false:true)" type="button" class="btn btn-link close-ic" (click)="onClickToDeleteAttachment(file.filePath, true)">
                <img src="../../../../assets/images/creditor-portal/activity-close-ic.svg" alt="closeIcon" />
              </button>
              <button *ngIf="(file.isUpdate?true:false) && (file.isView?false:true)" type="button" class="btn btn-link close-ic" (click)="onClickRemoveFile(file.filePath,true)">
                <img src="../../../../assets/images/creditor-portal/activity-close-ic.svg" alt="closeicon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
